module.exports = __webpack_public_path__ + "static/media/close-icon.5bea4576.svg";